(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DataFormatter_ru", [], factory);
	else if(typeof exports === 'object')
		exports["DataFormatter_ru"] = factory();
	else
		root["DataFormatter_ru"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  name: 'ru',
	  months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
	  monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
	  days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
	  daysShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
	  thousandSeparator: ' ',
	  decimalSeparator: ',',
	  formats: {
	    'General Number': '#.#',
	    'Currency': '#,##0.00р.;[Red]-#,##0.00р.',
	    'Fixed': '0.00',
	    'Standard': '#,##0.00',
	    'Percent': '0.00%',
	    'Scientific': '0.00E+00',
	    'Yes/No': '"Да";"Да";"Нет"',
	    'True/False': '"Истина";"Истина";"Ложь"',
	    'On/Off': '"Вкл";"Вкл";"Выкл"',
	    'Short Date': 'mm.dd.yyyy',
	    'Long Date': 'dd mmmm yyyy',
	    'General Date': 'mm.dd.yyyy h:mm',
	    'Medium Date': 'dd.mmm.yy',
	    'Long Time': 'hh:mm:ss AM/PM',
	    'Short Time': 'h:mm',
	    'Medium Time': 'hh:mm AM/PM'
	  }
	};

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// ru.js